import React from 'react';
import { motion } from 'framer-motion';
import { SunIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productBrand, productEdition, productImage, productImageAlt } from '../data/offer';
export function Hero() {
  const scrollToOffer = () => document.getElementById('offerta')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden" data-id="element-82" data-mp="129h1nq0lv4eh">
      <div className="h-1 w-full bg-gradient-to-r from-energy via-aqua to-energy" aria-hidden="true" data-id="element-83" data-mp="128yz6bncnty4" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-84" data-mp="xb5tdjpyl1yd">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-energy/40 bg-navy-card px-4 py-2 text-[11px] font-bold uppercase tracking-[.14em] text-cream sm:text-xs" data-id="element-85" data-mp="s9q75oc1opee">
          <SunIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-86" data-mp="3j9k9f79139e0" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-8 max-w-3xl" data-id="element-87" data-mp="3o6u71a6kmrcx">
          <div className="pointer-events-none absolute inset-[8%] -z-10 rounded-full opacity-60 blur-3xl" style={{
          background: 'radial-gradient(circle, rgba(34,197,94,0.35) 0%, rgba(56,189,248,0.22) 45%, transparent 72%)'
        }} aria-hidden="true" data-id="element-88" data-mp="30h9ebzkm8fqg" />
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full drop-shadow-[0_0_28px_rgba(34,197,94,0.25)]" data-id="element-89" data-mp="2viewp0ydwx7x" />
        </motion.div>

        <div className="mt-8" data-id="element-90" data-mp="2hjynn3d1uumm">
          <Button onClick={scrollToOffer} arrow className="w-full sm:w-auto" data-id="element-91" data-mp="2lkqwhvi0exid">
            Voglio l&apos;Edizione Docenti
          </Button>
        </div>
      </div>
    </section>;
}